import { render, staticRenderFns } from "./hotelProductInquiryShow.vue?vue&type=template&id=c2c6c238"
import script from "./hotelProductInquiryShow.vue?vue&type=script&lang=js"
export * from "./hotelProductInquiryShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c6c238')) {
      api.createRecord('c2c6c238', component.options)
    } else {
      api.reload('c2c6c238', component.options)
    }
    module.hot.accept("./hotelProductInquiryShow.vue?vue&type=template&id=c2c6c238", function () {
      api.rerender('c2c6c238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/child/hotelProductInquiryShow.vue"
export default component.exports